import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=2b4e8562"
import script from "./Title.vue?vue&type=script&lang=ts"
export * from "./Title.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports